import StyledChannelViewContainer from '@components/atoms/container/styledChannelViewContainer';
import SelectViewContainer from '@components/atoms/container/selectViewContainer';
import ChannelViewTitle from '@components/atoms/text/channelViewTitle';
import ChannelViewWindow from '@components/atoms/images/channelViewWindow';
import SelectViewButton from '@components/atoms/buttons/selectViewButton';
import TranslationManager from '@shared/assets/locale/translationsManager';
import type Props from '../../../../shared/types/props/button';
import useList from '@shared/components/utils/hooks/useList';

type ChannelViewProps = {
  text: string;
  Icon: React.FC<Props>;
  image: string;
  index: number;
};

export default function ChannelViewContainer({
  text,
  Icon,
  image,
  index,
}: ChannelViewProps) {
  const { focused, listIndex } = useList(index);

  return (
    <StyledChannelViewContainer>
      <SelectViewContainer>
        <Icon width={63} height={67} margin={'44px 0 0 0'}></Icon>
        <ChannelViewTitle>{text}</ChannelViewTitle>
        <ChannelViewWindow src={image} />
      </SelectViewContainer>
      <SelectViewButton focused={focused && listIndex === index}>
        {TranslationManager.get('PAGES.CHANNELS_CHOICE.BUTTON')}
      </SelectViewButton>
    </StyledChannelViewContainer>
  );
}
